<div class="card mapfre-fs-xs-r">
  <div class="card__section-1">
    <div class="card__title">
      <img
        class="card__title-icon"
        alt="Payment plan icon"
        src="assets/images/payment-plan/payment-plan-title.svg"
      />
      <div class="card__title-text"
        >{{ 'PAYMENT_PLAN.LIST.CARD_TITLE' | translate }}
        <strong>{{ plan.id }}</strong></div
      >
    </div>

    <div *ngIf="plan.paymentPendingFees?.length" class="card__payment-title">
      <img
        src="assets/images/payment-plan/warning.svg"
        alt="Warning"
        class="card__payment-title-warning"
      />
      <span class="card__payment-title-text"
        >{{ plan.paymentPendingFees[0]?.effectDate | date:'MMMM yyyy':'':'es' }}
        -
        <strong
          >{{ plan.paymentPendingFees[0]?.amount | number:'1.2-2': 'es' }}
          &euro;</strong
        ></span
      >
    </div>

    <div *ngIf="plan.paymentPendingFees?.length" class="card__payment">
      <div class="card__payment-pending"
        >{{ 'PAYMENT_PLAN.LIST.PENDING_PAYMENT' | translate }}</div
      >
      <a class="card__payment-button h-focus" (click)="onPay()" analyticsDisable>
        {{ 'PAYMENT_PLAN.LIST.PENDING_PAYMENT_BUTTON' | translate }}
      </a>
    </div>
  </div>

  <div
    class="card__section-2"
    [ngClass]="{ 'hide-border-section-2': changeCardDesign }"
  >
    <div class="card__info">
      <div *ngIf="plan.nextFee" class="card__info-quota mapfre-mb-s">
        <span
          >{{ 'PAYMENT_PLAN.LIST.QUOTA' | translate }} {{
          plan.nextFee.effectDate | date:'MMM yyyy':'':'es' | uppercase }}</span
        >
        <span
          ><strong
            >{{ plan.nextFee.amount | number:'1.2-2': 'es' }} &euro;</strong
          ></span
        >
      </div>
      <div class="card__info-date">
        <span>{{ 'PAYMENT_PLAN.LIST.PAYMENT_DATE' | translate }}</span>
        <span
          ><strong
            >{{ plan.paymentMonthDay }} {{ 'PAYMENT_PLAN.LIST.OF_EACH_MONTH' |
            translate }}</strong
          ></span
        >
      </div>
    </div>

    <div
      *ngIf="plan.summaryDocument || plan.contractDocument"
      class="card__documents"
      [ngClass]="{ 'mapfre-hide-mobile': hideCardDetail }"
    >
      <div class="card__section-title"
        >{{ 'PAYMENT_PLAN.LIST.DOCUMENTS' | translate }}</div
      >
      <div class="card__items">
        <button
          *ngIf="plan.summaryDocument"
          class="card__document"
          (click)="getPaymentPlanDocument('summary')"
          analyticsDisable
        >
          {{ 'PAYMENT_PLAN.LIST.DOCUMENT_SUMMARY' | translate }}
        </button>
        <button
          *ngIf="plan.contractDocument"
          class="card__document"
          (click)="getPaymentPlanDocument('contract')"
          analyticsDisable
        >
          {{ 'PAYMENT_PLAN.LIST.DOCUMENT_CONTRACT' | translate }}
        </button>
      </div>
    </div>

    <div
      *ngIf="plan.receiptDocuments?.length"
      class="card__receipts"
      [ngClass]="{ 'mapfre-hide-mobile': hideCardDetail }"
    >
      <div class="card__section-title"
        >{{ 'PAYMENT_PLAN.LIST.RECEIPTS' | translate }}</div
      >
      <div class="card__items">
        <button
          *ngIf="plan.lastReceiptDocument"
          class="card__document"
          (click)="getPaymentPlanDocument('receipt')"
          analyticsDisable
        >
          {{ 'PAYMENT_PLAN.LIST.LAST_RECEIPT' | translate }} {{
            plan.lastReceiptDocument.date | date:'MMMM yyyy':'':'es' | titlecase
          }}
        </button>
        <a class="card__link" (click)="onBills()" analyticsDisable
          >{{ 'PAYMENT_PLAN.LIST.PREVIOUS_RECEIPTS' | translate }}</a
        >
      </div>
    </div>
  </div>

  <div
    class="card__section-3"
    verticalCollapse
    [trigger]="trigger"
    [ngClass]="{ 'border-top': hideCardDetail, 'hide-border-section-3': changeCardDesign }"
  >
    <div>
      <div class="card__section-title">
        {{ 'PAYMENT_PLAN.LIST.POLICIES_TITLE' | translate }} ({{
        plan.policyNumbers?.length }})
      </div>
      <div class="card__policies">
        <ng-container *ngFor="let policyNumber of plan.policyNumbers">
          <div class="card__policy">
            <ng-container *ngIf="auth.checkUserIsParticular()">
              <ng-container
              *ngIf="_productCards[policyNumber] as policy; else policyNotOwned"
              >
                <div
                  >{{ policy.title + (policy.endTitle ? ' ' + policy.endTitle :
                  '') | uppercase }}</div
                >
                <div>{{ policy.subtitle | titlecase }}</div>
                <div>Póliza nº {{ policy.policy.policyNumber }}</div>
              </ng-container>
              <ng-template #policyNotOwned>
                <div>Póliza nº {{ policyNumber }}</div>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="auth.checkUserIsCompany()">
              <ng-container
              *ngIf="_policiesCardsConfig[policyNumber] as policy; else policyNotOwned"
              >
                <div *ngIf="policy?.tertiaryDescription"
                  >{{ policy.tertiaryDescription + (policy.principalDescription ? ' ' + policy.principalDescription :
                  '') | uppercase }}
                </div>

                <div *ngIf="!policy?.tertiaryDescription"
                >{{ policy.principalDescription }}
                </div>

                <div>{{ policy.secondaryDescription | titlecase }}</div>
                <div>Póliza nº {{ policyNumber }}</div>
              </ng-container>
              <ng-template #policyNotOwned>
                <div>Póliza nº {{ policyNumber }}</div>
              </ng-template>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <button
    #trigger
    class="btn-show"
    (click)="onShowMore()"
    [ngClass]="{ 'border-top': hideCardDetail }"
  >
    <div
      class="btn-show--more"
      [ngClass]="{ 'btn-show--less': !hideCardDetail }"
    >
      <span
        >{{ (hideCardDetail) ? ('PAYMENT_PLAN.LIST.SHOW_MORE' | translate) :
        ('PAYMENT_PLAN.LIST.SHOW_LESS' | translate) }}</span
      >
      <img src="assets/images/show-more.svg" alt="Show-more" />
    </div>
  </button>
</div>
